import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PermissionService } from './components/permission-modal/permission.service';
import { GlobalChatWsService } from './core/global-chat-ws.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent {

    constructor(
        private permissionService: PermissionService,
        private globalChatWs: GlobalChatWsService
    ) { }

    ngOnInit() {
        this.permissionService.load().subscribe();
        this.globalChatWs.init();
    }

}
